var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRatingStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.10352e-05L11.0206 6.21891H17.5595L12.2694 10.0624L14.2901 16.2812L9 12.4378L3.70993 16.2812L5.73056 10.0624L0.440492 6.21891H6.97937L9 6.10352e-05Z",
    fill: "#FBA929"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRatingStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rating-star.5933338c9e01edeb7d4468932aed45ca.svg";